import Transactions from "./pages/Transactions/Transactions";
import Dashboard from "./pages/dashboard/Dashboard";
import Settlement from "./pages/settlement/Settlement";
import { Login } from "@rewardle/apps.ui.login.login";
import { Forgotpassword } from "@rewardle/apps.ui.forgotpassword.forgotpassword";
import { Signupprocess } from "@rewardle/apps.ui.signup.signupprocess";
import { Unauthorisedlayout } from "@rewardle/apps.auth.unauthorisedlayout.unauthorisedlayout";
import Staffs from "./pages/staff/Staffs";
import StaffDetails from "./pages/staff/StaffDetails";
import Payments from "./pages/paymentDetails/Payments";

const actionCodeSettings = {
  url: `${process.env.REACT_APP_API_URL}`,
  handleCodeInApp: true,
  dynamicLinkDomain: process.env.REACT_APP_DYNAMIC_LINK_DOMAIN
};

export const authedRoutes = [
  {
    path: "/",
    element: <Dashboard />
  },
  {
    path: "dashboard",
    element: <Dashboard />
  },
  {
    path: "transactions",
    element: <Transactions />
  },
  {
    path: "settlements",
    element: <Settlement />
  },
  {
    path: "staffs",
    element: <Staffs />
  },
  {
    path: "staff",
    element: <StaffDetails />
  },
  {
    path: "staff/:id",
    element: <StaffDetails />
  },
  {
    path: "paymentdetails",
    element: <Payments />
  }
];

export const unAuthedRoutes = [
  {
    path: "/",
    element: <Login authorizationName={"BusinessAuthorization"} />
  },
  {
    path: "login",
    element: <Login authorizationName={"BusinessAuthorization"} />
  },
  {
    path: "forgot-password",
    element: (
      <Forgotpassword
        actionCodeSettings={actionCodeSettings}
        authorizationName={"BusinessAuthorization"}
      />
    )
  },
  {
    path: "get-started",
    element: <Signupprocess />
  }
];

export const unAuthorisedlayout = [
  {
    path: "/",
    element: <Unauthorisedlayout />
  },
  {
    path: "unauthorised",
    element: <Unauthorisedlayout />
  }
];
